import { SxProps, Theme } from '@mui/material'

export const drawerMarginSx = (open: boolean, widths: Record<string, number>): SxProps<Theme> => ({
  transition: (theme: Theme) =>
    theme.transitions.create('margin', {
      easing: open ? theme.transitions.easing.easeOut : theme.transitions.easing.sharp,
      duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
    }),
  marginRight: open
    ? (Object.fromEntries(Object.entries(widths).map(([bp, w]) => [bp, `${w}px`])) as Record<string, string>)
    : 0,
})
